import api from '../api/axios';

export const checkAtsResume = async (formData) => {
  const response = await api.post('/resume/ats-check', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const matchResumeToJob = async (formData) => {
  const response = await api.post('/resume/jd-match', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const generateColdEmail = async (payload, isFormData = false) => {
  const config = isFormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined;

  const response = await api.post('/email/generate', payload, config);
  return response.data;
};

export const generateProjectBullets = async (projectDetails) => {
  const response = await api.post('/bullets/generate', { projectDetails });
  return response.data;
};
